module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "larger"
  }, [_vm._v("Once Later")]), _vm._v(" "), _c('blockquote', {
    staticClass: "indent3"
  }, [_c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("It is not until later")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("that you have to be young")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("it is one of the things")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("you meant to do later")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("but by then there is")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("someone else living there")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("with the shades rolled down")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("how could you have been young there")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("at that time")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("with all that was expected")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("then what happened to")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("the expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("there is no sign of them there")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("a shadow passes across the window")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("shade")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("what do they know in there")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_c('em', [_vm._v("whoever they are")])]), _vm._v(" "), _c('p', {
    staticClass: "right "
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("—W. S. MERWIN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-134c44ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front03.vue
// module id = 69
// module chunks = 0